"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var Col = function (props) {
    var span = props.span, children = props.children;
    var colSize = (span || 12) * 2;
    return (react_1.default.createElement(antd_1.Col, { xs: 24, sm: 24, md: colSize, lg: colSize, xl: colSize }, children));
};
exports.default = Col;
